export const dogerBlue = "#2367ff";
export const zumthor = "#e5edff";
export const mineShaft = "#303030";
export const alto = "#d1d1d1";
export const periwinkle = "#d4e1ff";
export const fruitSalad = "#4caf50";
export const hintOfGreen = "#e5ffe7";
export const pizazz = "#fb8c00";
export const citrineWhite = "#fbf0e2";
export const sunsetOrange = "#ff5151";
export const pippin = "#FFE5E5";

export const poolWater = "#0083ef";

export const neonCarrot = "#fb9c15";
export const royalPurple = "#390b73";

export const purple_1 = "#E5B8F4";
export const purple_2 = "#C147E9";
export const purple_3 = "#810CA8";
export const purple_4 = "#2D033B";

export const leadingColor = "#81427c";
